import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferWidgetComponent } from './components/widgets/offer-widget/offer-widget.component';
import { OfferTransactionDialogComponent } from './components/dialog/offer-transaction-dialog/offer-transaction-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { LocationModule } from '../location/location.module';
import { CustomerModule } from '../customer/customer.module';
import { OfferItemsFormComponent } from './components/embedded/offer-items-form/offer-items-form.component';
import { OfferItemsForm2Component } from './components/embedded/offer-items-form2/offer-items-form2.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatStepperModule } from '@angular/material/stepper';
import { SharedModule } from '../shared/shared.module';
import { OfferFormComponent } from './components/embedded/offer-form/offer-form.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { OfferPreviewComponent } from './components/previews/offer-preview/offer-preview.component';
import { MatSortModule } from '@angular/material/sort';
import { SelectOfferDialogComponent } from './components/dialog/select-offer-dialog/select-offer-dialog.component';
import { OfferDetailsComponent } from './components/main/offer-details/offer-details.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { QuillModule } from 'ngx-quill';
import { SelectStatusFormComponent } from './components/select/select-status-form/select-status-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CreateOfferComponent } from './components/dialog/create-offer/create-offer.component';

@NgModule({
  declarations: [
    OfferFormComponent,
    OfferItemsFormComponent,
    OfferItemsForm2Component,
    OfferPreviewComponent,
    OfferTransactionDialogComponent,
    OfferWidgetComponent,
    SelectOfferDialogComponent,
    OfferDetailsComponent,
    SelectStatusFormComponent,
    CreateOfferComponent
  ],
  imports: [
    CommonModule,
    CustomerModule,
    FormsModule,
    LocationModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSortModule,
    MatCheckboxModule,
    MatStepperModule,
    MatTableModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatSelectModule,
    ReactiveFormsModule,
    SharedModule,
    QuillModule.forRoot({ })
  ],
  exports: [
    OfferTransactionDialogComponent,
    OfferPreviewComponent,
    OfferWidgetComponent,
    SelectOfferDialogComponent
  ]
})
export class OfferModule { }
